import { useEffect } from 'react';

export default function usePageLogging(pageType: string) {
  useEffect(() => {
    // Intentionally added this log, to make debugging pages easier
    // eslint-disable-next-line no-console
    console.log(`${pageType}: ${window.location.pathname}`);
  }, [pageType]);
}
